import {Component, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {TranslatePipe} from '@ngx-translate/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {AsyncPipe} from '@angular/common';
import {HeaderComponent} from '../../components/header/header.component';
import {FooterContactComponent} from '../../components/footer-contact/footer-contact.component';
import {FooterInfoComponent} from '../../components/footer-info/footer-info.component';
import {VotingFormComponent} from '../../components/voting-form/voting-form.component';
import {ContentSectionsComponent} from '../../components/content-sections/content-sections.component';
import {HtmlContentComponent} from '../../components/html-content/html-content.component';
import {VoteValue} from '../../enums/vote-value.enum';
import {AppState} from '../../store/store';
import {makeVote} from '../../store/portal/portal.actions';
import {
  selectHomePage,
  selectVotingFormData,
} from '../../store/portal/portal.selectors';
import {PageTitleComponent} from '../../components/page-title/page-title.component';
import {CommonSpacerComponent} from '../../components/common-spacer/common-spacer.component';
import {selectIsPreviewMode} from '../../store/shared-link/shared-link.selectors';

@Component({
  selector: 'app-voting',
  imports: [HeaderComponent, FooterContactComponent, FooterInfoComponent, VotingFormComponent, ContentSectionsComponent,
    HtmlContentComponent, TranslatePipe, PageTitleComponent, CommonSpacerComponent, MatProgressSpinner, AsyncPipe],
  templateUrl: './voting.component.html',
  styleUrl: './voting.component.scss',
})
export class VotingComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  public votingFormData$ = this.store.select(selectVotingFormData);

  public homePage$ = this.store.select(selectHomePage);

  public previewMode$ = this.store.select(selectIsPreviewMode);

  handleVoting(voteValue: VoteValue): void {
    this.store.dispatch(makeVote({voteValue}));
  }

}
